export default {options:{api:'submit',version:1},children:[{options:{key:'channel',type:'value'}},{options:{key:'timestamp',type:'value'}}]}